module.exports = __webpack_public_path__ + "static/media/bracelet.7b81e92e.png";